export const Steps = {
    WELCOME: -1,
    BASIC: 0,
    PROFESSIONAL_INFO: 1,
    SERVICES_CENTER: 2,
    COMPLETE: 3
};
